module.exports = __webpack_public_path__ + "static/media/chess.434000d4.png";